import { isNotExists } from './is.utils';

export class ModelTransformerUtils {
  static fromDTO<Model, Dto>(ModelType: new (dto: Dto) => Model, dto: Dto | undefined): Model | null {
    return isNotExists(dto) ? null : new ModelType(dto!);
  }

  static fromArrayDTO<Model, Dto>(ModelType: new (dto: Dto) => Model, arr: Dto[] | null): Model[] {
    return arr?.map((d) => new ModelType(d)) ?? [];
  }
}
